if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();

        this.lastScrollTop = window.scrollY <= 0 ? 0 : window.scrollY;
        this.adjustment = 0;

        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');

        this.textLinks = this.querySelectorAll('.product__text .link');
        this.accordions = this.querySelectorAll('.product__accordion');
        this.summaries = this.querySelectorAll('.product__accordion summary');

        this.rebindLinks();

        this.summaries.forEach((node) => {
          node.addEventListener('click', this.handleSummaryClick.bind(this));
        });

        //window.addEventListener('scroll', this.handleScroll.bind(this));

        if (window.innerWidth > 750) {
          window.addEventListener(
            'scroll',
            throttle((e) => {
              this.handleScroll(e);
            }),
            { passive: true }
          );
        }
      }

      handleScroll(e) {
        // Large number to ensure that when scrolling up, the scroll adjustment is reset
        var max_adjustment = 1000000;

        var diff = window.scrollY - this.lastScrollTop;

        var window_height = window.innerHeight;

        var info_height = this.clientHeight;

        var header_groups = document.querySelectorAll('.shopify-section-header-sticky');
        var total_header_height = 0;

        if (header_groups.length > 0) {
          header_groups.forEach((header_group) => {
            total_header_height += header_group.clientHeight;
          });
        }

        if (window_height - total_header_height < info_height) {
          max_adjustment = info_height - (window_height - total_header_height);
        } else {
          max_adjustment = 0;
        }

        this.adjustment += diff;

        if (this.adjustment > max_adjustment) {
          this.adjustment = max_adjustment;
        } else if (this.adjustment < 0) {
          this.adjustment = 0;
        }

        this.style.top = `calc(5rem - ${this.adjustment}px)`;

        this.lastScrollTop = window.scrollY <= 0 ? 0 : window.scrollY;
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      rebindLinks() {
        this.textLinks = this.querySelectorAll('.product__text .link');

        this.textLinks.forEach((node) => {
          node.addEventListener('click', this.scrollToSection.bind(this));
        });

        this.notificationLinks = this.querySelectorAll('.product__notice a');

        this.notificationLinks.forEach((node) => {
          node.addEventListener('click', this.scrollToSection.bind(this));
        });
      }

      handleSummaryClick(e) {
        let target = e.target.closest('.product__accordion');

        this.accordions.forEach((node) => {
          if (node !== target) {
            const details = node.querySelector('details');

            if (details.hasAttribute('open')) {
              details.querySelector('summary').click();
            }
          }
        });

        if (!target.querySelector('details').hasAttribute('open')) {
          setTimeout(() => {
            const y = target.getBoundingClientRect().top + window.pageYOffset - 61;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }, 100);
        }
      }

      scrollToSection(e) {
        const link = e.target;

        if (link.getAttribute('href').indexOf('#') === -1) {
          return;
        } else {
          e.preventDefault();

          let target = document.querySelector(`#CollapsibleTab-${link.getAttribute('href').replace('#', '')}`);

          if (target) {
            if (target.classList.contains('product__accordion')) {
              this.accordions.forEach((node) => {
                if (node !== target) {
                  const details = node.querySelector('details');

                  if (details.hasAttribute('open')) {
                    details.querySelector('summary').click();
                  }
                } else {
                  const details = node.querySelector('details');
                  if (!details.hasAttribute('open')) {
                    details.querySelector('summary').click();
                  }
                }
              });
            }

            const y = target.getBoundingClientRect().top + window.pageYOffset - 61;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        }
      }

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

if (!customElements.get('size-guide')) {
  customElements.define(
    'size-guide',
    class SizeGuide extends HTMLElement {
      constructor() {
        super();

        this.controller = this.querySelector('.form__select');

        this.currentSizeSpan = this.querySelectorAll('.size-guide__current-size');

        this.table = this.querySelector('.size-guide__table');

        if (this.table) {
          this.classes = this.table.querySelectorAll('.size-guide__class');
          this.tableMeasurements = this.table.querySelectorAll('.size-guide__measurement');
        }

        this.bodyMeasures = this.querySelectorAll('.size-guide__body-measure');

        this.bodyTabs = this.querySelectorAll('.size-guide__units-tab--body');
        this.itemTabs = this.querySelectorAll('.size-guide__units-tab--item');

        this.currentItemUnit = 'in';
        this.currentBodyUnit = 'in';

        if (this.itemTabs) {
          this.itemTabs.forEach((node) => {
            node.addEventListener('click', this.changeItemTab.bind(this));
          });
        }

        if (this.bodyTabs) {
          this.bodyTabs.forEach((node) => {
            node.addEventListener('click', this.changeBodyTab.bind(this));
          });
        }

        this.controller.addEventListener('change', this.changeSize.bind(this));

        this.changeSize();

        if (this.itemTabs) {
          this.updateTableUnits();
        }

        if (this.bodyTabs) {
          this.updateMeasurementsUnits();
        }
      }

      setSize(size) {
        this.controller.querySelectorAll('option').forEach((node) => {
          if (node.textContent.trim() == size) {
            node.selected = true;
          }
        });

        this.currentSizeSpan.forEach((node) => {
          node.textContent = size;
        });

        this.changeSize();
      }

      changeSize(e) {
        this.currentIndex = this.controller.selectedIndex;

        const currentSize = this.controller.options[this.currentIndex].text;

        this.currentSizeSpan.forEach((node) => {
          node.textContent = currentSize;
        });

        if (this.classes) {
          const currentColumn = this.classes[this.currentIndex];

          currentColumn.parentElement.scrollTo({
            left: currentColumn.clientWidth * Math.max(this.currentIndex - 1, 0),
          });
        }

        this.bodyMeasures.forEach((node) => {
          if (node.dataset.size == this.controller.value) {
            node.setAttribute('aria-current', 'true');
          } else {
            node.setAttribute('aria-current', 'false');
          }
        });
      }

      changeBodyTab(e) {
        if (e) {
          this.currentBodyUnit = e.target.dataset.value;
        }

        if (this.currentBodyUnit != this.currentItemUnit) {
          this.currentItemUnit = this.currentBodyUnit;

          this.changeItemTab();
        }

        this.bodyTabs.forEach((node) => {
          if (node.dataset.value == this.currentBodyUnit) {
            node.setAttribute('aria-selected', 'true');
            node.classList.add('active');
          } else {
            node.setAttribute('aria-selected', 'false');
            node.classList.remove('active');
          }
        });

        this.updateMeasurementsUnits();
      }

      changeItemTab(e) {
        if (e) {
          this.currentItemUnit = e.target.dataset.value;
        }

        if (this.currentBodyUnit != this.currentItemUnit) {
          this.currentBodyUnit = this.currentItemUnit;

          this.changeBodyTab();
        }

        this.itemTabs.forEach((node) => {
          if (node.dataset.value == this.currentItemUnit) {
            node.setAttribute('aria-selected', 'true');
            node.classList.add('active');
          } else {
            node.setAttribute('aria-selected', 'false');
            node.classList.remove('active');
          }
        });

        this.updateTableUnits();
      }

      updateTableUnits() {
        if (this.tableMeasurements) {
          this.tableMeasurements.forEach((node) => {
            if (this.currentItemUnit == 'in') {
              if (node.dataset.unit == 'cm') {
                node.textContent = `${Number(node.textContent / 2.54).toFixed(1)}`;
              }
            } else if (this.currentItemUnit == 'cm') {
              if (node.dataset.unit == 'in') {
                node.textContent = `${Number(node.textContent * 2.54).toFixed(1)}`;
              }
            }

            node.dataset.unit = this.currentItemUnit;
          });
        }
      }

      updateMeasurementsUnits() {
        this.bodyMeasures.forEach((node) => {
          let bodyMeasuresUnits = node.querySelectorAll('span');

          bodyMeasuresUnits.forEach((unit) => {
            if (this.currentBodyUnit == 'in') {
              if (node.dataset.unit == 'cm') {
                unit.textContent = `${Number(unit.dataset.decimal)}`;
              }
            } else if (this.currentBodyUnit == 'cm') {
              if (node.dataset.unit == 'in') {
                unit.textContent = `${Math.floor(Number(unit.dataset.initialMeasurement * 2.54))}`;
              }
            }
          });

          node.dataset.unit = this.currentBodyUnit;
        });
      }
    }
  );
}
